import { useNavigate as useRouterNavigate, matchPath } from "react-router";
import { useSelector } from "react-redux";
import { curStateAccount } from "@/Redux/selector";
import { hasAuthCookie } from "@/utils/auth";
import { IS_UPDATE_VERSION_3_PROJECT } from "@/helper/const";
import { useLoginModal } from "@/contexts/LoginModalContext";
import { routerList } from "@/config/routerList";

export function useAppNavigate() {
	const routerNavigate = useRouterNavigate();
	const { openLogin } = useLoginModal();
	const account = useSelector(curStateAccount);

	const isAuthed =
		hasAuthCookie() || Boolean(account?.userInfo) || Boolean(account?.token);

	return (to, options) => {
		const path = typeof to === "string" ? to : to?.pathname;

		const matchedRoute = routerList.find((r) => matchPath(r.path, path));
		const needAuth = matchedRoute && !matchedRoute.public;

		if (needAuth && !isAuthed && IS_UPDATE_VERSION_3_PROJECT) {
			openLogin(() => routerNavigate(to, options));
			return;
		}

		routerNavigate(to, options);
	};
}